import React, { useState, useEffect } from "react";
import { AmeaRoutesCategoriesContext } from "./context";

import { getRoutesCategories } from "../services/services";

const AmeaRoutesCategoriesProvider = ({ children }) => {
  const [routesCategoriesData, setRoutesCategoriesData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRoutesCategories = async () => {
      const RoutesCategories = await getRoutesCategories({ lang: "el" })
        .then((response) => {
          if (response.length > 0) {
            setLoading(false);
            return response;
          } else {
            setLoading(false);
            return [];
          }
        })
        .catch((error) => {
          setLoading(false);
          setError(error);
        });

      //   const tempSensorTypes = [
      //     {
      //       id: "122",
      //       title: "Υποδομές ΑΜΕΑ",
      //     },
      //   ];

      setRoutesCategoriesData(RoutesCategories);
    };

    fetchRoutesCategories();
  }, []);

  return (
    <AmeaRoutesCategoriesContext.Provider
      value={{
        get: routesCategoriesData,
        set: setRoutesCategoriesData,
        loading,
        error,
      }}
    >
      {children}
    </AmeaRoutesCategoriesContext.Provider>
  );
};

export default AmeaRoutesCategoriesProvider;
